import * as React from "react"
const Visitor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={19}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#000"
        d="M2.987 6.033a4.125 4.125 0 1 1 6.447 3.41 6.753 6.753 0 0 1 4.425 6.135.563.563 0 0 1-1.125.034 5.625 5.625 0 0 0-11.245 0 .562.562 0 0 1-1.124-.033A6.754 6.754 0 0 1 4.79 9.443a4.122 4.122 0 0 1-1.803-3.41Zm4.125-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm6.217 3c-.11 0-.219.007-.325.022a.562.562 0 1 1-.16-1.113 3.397 3.397 0 0 1 2.536 6.073 5.017 5.017 0 0 1 2.967 4.58.563.563 0 0 1-1.125 0 3.895 3.895 0 0 0-2.772-3.729l-.4-.12V10.49l.307-.156a2.273 2.273 0 0 0-1.028-4.3Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.362.034h18v18h-18z" />
      </clipPath>
    </defs>
  </svg>
)
export default Visitor